import React, {useEffect, useState} from 'react';
import ShowTabsList from "../../../common/ui/show-tabs-list";
import {
    CAMPAIGN_DESIGN_DETAIL_TABS_LIST,
    CAMPAIGN_DESIGN_SECONDARY_ATTRIBUTES,
    DEFAULT_CAMPAIGN_DESIGN_DETAIL_TAB
} from "../../constants/campaign.constant";
import DesignDetailTable from "../../../design/components/publisher/design-detail-table";
import TargetingInterestsList from "../targeting-interest/targeting-interest-list";
import _ from "lodash";
import {
    addSingleTargetingInterest,
    searchTargetingInterestsWithSearchCriteria,
    updateSingleTargetingInterest
} from "../../services/facebook-targeting-interest-data.service";
import {prepareDesignSearchInterestList} from "../../utils/facebook-interest-util";
import SearchTargetingInterest from "../targeting/search-targeting-interest";
import AddEditAdSet from "../ad-set/add-edit-ad-set";
import AdSetList from "../ad-set/ad-set-list";


const tabsList = CAMPAIGN_DESIGN_DETAIL_TABS_LIST;

const CampaignDesignDetail = ({
                                  designDetail,
                                  designInfo,
                                  campaign,
                                  parentProduct,
                                  parentProductSearchInterestList,
                                  campaignInterests,
                                  setCampaignInterests
                              }) => {
    const [selectedTab, setSelectedTab] = useState(DEFAULT_CAMPAIGN_DESIGN_DETAIL_TAB);
    const [interestsList, setInterestsList] = useState([]);
    const [facebookTargetingInterest, setFacebookTargetingInterest] = useState({} as any);
    const [refreshList, setRefreshList] = useState(false);

    useEffect(() => {
        if (designDetail) {
            prepareFacebookSearchInterests();
            getFacebookTargetingInterest();
            refreshAdSetList();
        }
    }, [designDetail?.id]);

    const prepareFacebookSearchInterests = () => {
        let searchInterestTextList = prepareDesignSearchInterestList(designDetail, parentProductSearchInterestList);
        setInterestsList(searchInterestTextList);
    }
    const getFacebookTargetingInterest = async () => {
        const searchCriteriaList = [];
        searchCriteriaList.push({field: 'designId', condition: '==', value: designDetail?.id});
        const facebookTargetingInterestsResult = await searchTargetingInterestsWithSearchCriteria(searchCriteriaList);

        if (facebookTargetingInterestsResult?.length > 0) {
            setFacebookTargetingInterest(facebookTargetingInterestsResult[0]);
        } else {
            setFacebookTargetingInterest(null);
        }
    }

    const afterSearchInterestsResult = async (interestsMap) => {
        let existingFacebookTargetingInterest: any = {...facebookTargetingInterest};
        const existingCampaignInterests = {...campaignInterests};
        const newInterests = _.keys(interestsMap);
        const commonInterestIds = _.intersectionWith(existingCampaignInterests?.all, newInterests, _.isEqual);

        if (!_.isEmpty(existingFacebookTargetingInterest)) {
            existingFacebookTargetingInterest['interests'] = interestsMap;
            existingFacebookTargetingInterest['relevantInterests'] = _.uniq(_.concat(existingFacebookTargetingInterest['relevantInterests'], commonInterestIds));

            await updateSingleTargetingInterest(existingFacebookTargetingInterest);
            setFacebookTargetingInterest(existingFacebookTargetingInterest);
        } else {
            const newFacebookTargetingInterest = {
                designId: designDetail?.id,
                interests: interestsMap,
                relevantInterests: commonInterestIds
            }

            const addedDoc = await addSingleTargetingInterest(newFacebookTargetingInterest);
            newFacebookTargetingInterest['id'] = addedDoc.id;
            setFacebookTargetingInterest(newFacebookTargetingInterest);
        }
    }

    const refreshAdSetList = () => {
        setRefreshList(true);
    }

    return (
        <>

            <div className="page-container">

                <div className="items-center justify-start  px-4 pb-4 w-full">
                    <div className="flex justify-between">

                        <div>
                            <div className="text-lg flex justify-start">
                                <div className="mr-1 text-purple-700 font-semibold">{designInfo?.name}</div>
                                {facebookTargetingInterest?.relevantInterests?.length > 0 &&
                                    <div
                                        className={'ml-2 px-2 py-1 text-center self-center text-sm -mt-1 border border-blue-800 bg-blue-100 text-blue-800 rounded-xl'}>
                                        {facebookTargetingInterest?.relevantInterests?.length} Interests
                                    </div>
                                }
                            </div>
                            <div>
                                {CAMPAIGN_DESIGN_SECONDARY_ATTRIBUTES?.map((secondaryAttribute, secondaryAttributeIndex) => (
                                    <React.Fragment
                                        key={`secondary-attribute-${secondaryAttributeIndex}`}>
                                        {designInfo[secondaryAttribute] &&
                                            <span className={'text-gray-500'}>
                                                {designInfo[secondaryAttribute]}
                                                {secondaryAttributeIndex < CAMPAIGN_DESIGN_SECONDARY_ATTRIBUTES?.length - 1 &&
                                                    <span className={'mx-1'}>|</span>
                                                }
                                            </span>
                                        }
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>

                        <div className={'flex justify-end items-center'}>
                            <SearchTargetingInterest
                                afterSearch={afterSearchInterestsResult}
                                searchTextList={interestsList}/>

                            <div className="ml-2">
                                <AddEditAdSet
                                    refreshAdSetList={refreshAdSetList}
                                    designDetail={designDetail}
                                    facebookTargetingInterest={facebookTargetingInterest}
                                    campaign={campaign}
                                    isAddAdSet={true}/>
                            </div>
                        </div>
                    </div>


                    <div className="justify-center">

                        <div className="justify-start p-4">

                            <div>
                                <ShowTabsList
                                    setSelectedTab={setSelectedTab}
                                    selectedTab={selectedTab}
                                    tabsList={tabsList}/>
                            </div>

                            <div className="mt-4 px-4">

                                {selectedTab?.key === 'details' &&
                                    <div>
                                        <DesignDetailTable
                                            isTagTextList={true}
                                            parentProduct={parentProduct}
                                            designTagList={designDetail?.designTags}
                                            designDetail={designDetail}/>
                                    </div>
                                }

                                {selectedTab?.key === 'ad-sets' &&
                                    <div>
                                        <AdSetList
                                            refreshList={refreshList}
                                            setRefreshList={setRefreshList}
                                            designDetail={designDetail}
                                            campaign={campaign}/>
                                    </div>
                                }

                                {selectedTab?.key === 'facebook-interests' &&
                                    <div className="mt-4 mb-10 w-full">

                                        <TargetingInterestsList
                                            campaignInterests={campaignInterests}
                                            setCampaignInterests={setCampaignInterests}
                                            facebookTargetingInterest={facebookTargetingInterest}
                                            setFacebookTargetingInterest={setFacebookTargetingInterest}/>

                                    </div>
                                }

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </>
    )
}

export default CampaignDesignDetail
